module.exports = __webpack_public_path__ + "img/no-money.14d5ceb7.png";